// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerShipToAddressStyles } from "@conklin/Overrides/Widgets/Common/HeaderShipToAddress";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

headerShipToAddressStyles.titleTypography = {
    size: 12,
    lineHeight: "15px",
    weight: fontConfig.weight.regular,
    ellipsis: true,
    css: css`
        max-width: 600px;
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        column-gap: 6px;
        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
            row-gap: 6px;
        }
    `,
};

headerShipToAddressStyles.shipToAddressClickable = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        font-size: 12px;
        line-height: 15px;
        font-weight: ${fontConfig.weight.bold};
        margin-left: 2px;
        color: ${color("common.ui9")};

        &:not(:disabled):hover {
            color: ${color("common.ui10")};
        }
    `,
};
